export const toggleDarkMode = () => {
  return {
    type: 'TOGGLE_DARK_MODE'
  }
};
